// ModalWithTimer.tsx
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown';
import '@leenguyen/react-flip-clock-countdown/dist/index.css';
import { Box, Dialog, DialogContent, DialogTitle, Typography, useMediaQuery, useTheme } from '@mui/material';
import { addDays } from 'date-fns';
import React, { memo, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import LazyImage from '../components/LazyImage';
import { styled } from './styles';
import ReactCountdown from 'react-countdown';
import LanguagePicker from '@widgets/landing/lib/components/header/picker';
import { useSearchParams } from 'next/navigation';

const MyTimer = ({ endDate, onComplete }: { endDate: Date; onComplete?: () => void }) => {
  const t = useTranslations();
  const isTablet = useMediaQuery('(max-width: 768px)');
  const theme = useTheme();

  return (
    <ReactCountdown
      date={endDate}
      onComplete={onComplete}
      renderer={({ formatted: { hours, minutes, seconds } }) => (
        <div className='timer_list'>
          <div className='timer_block'>
            <div className='timer_number'>
              {hours.split('').map((num, index) => (
                <span className='timer_number_num' key={`${num}-${index}-hours`}>
                  {num}
                </span>
              ))}
            </div>
            <div className='timer_label' style={{ color: theme.palette.primary.main }}>
              {t('common.time.hourse')}
            </div>
          </div>
          <div className='timer_separator'>:</div>
          <div className='timer_block'>
            <div className='timer_number'>
              {minutes.split('').map((num, index) => (
                <span className='timer_number_num' key={`${num}-${index}-minutes`}>
                  {num}
                </span>
              ))}
            </div>
            <div className='timer_label' style={{ color: theme.palette.primary.main }}>
              {t('common.time.minutes')}
            </div>
          </div>
          <div className='timer_separator'>:</div>
          <div className='timer_block'>
            <div className='timer_number'>
              {seconds.split('').map((num, index) => (
                <span className='timer_number_num' key={`${num}-${index}-seconds`}>
                  {num}
                </span>
              ))}
            </div>
            <div className='timer_label' style={{ color: theme.palette.primary.main }}>
              {t('common.time.seconds')}
            </div>
          </div>
        </div>
      )}
      className='timer_modal'
    />
  );
};

interface Props {
  open: boolean;
  onClose: () => void;
  className?: string;
}

let TimerModal: React.FC<Props> = ({ open, onClose, className }) => {
  const [targetDate, setTargetDate] = useState<Date | null>(null);
  const [localHide, setLocalHide] = useState(false);
  useEffect(() => {
    if (!open) return;
    // const baseUTC = new Date(Date.UTC(2025, 8, 11, 0, 0, 0, 0));

    const targetDate = new Date(Date.UTC(2025, 11, 22, 15, 0, 0, 0));
    // const targetDate = new Date(Date.UTC(2025, 8, 16, 0, 0, 0, 0));

    // const midnightTomorrow = new Date();
    // midnightTomorrow.setHours(0, 0, 0, 0);
    // midnightTomorrow.setDate(midnightTomorrow.getDate() + 1);
    // const targetDate = addDays(midnightTomorrow, 17);

    setTargetDate(targetDate);
    const now = new Date();
    const msUntilEnd = targetDate.getTime() - now.getTime();

    // Если время уже истекло
    if (msUntilEnd <= 0) {
      onClose();
      setLocalHide(true);

      return;
    }

    // Закрыть модалку, когда таймер истечет
    const timeout = setTimeout(() => {
      console.log('TIMEOUT CLOSE ' + msUntilEnd);
      onClose();
    }, msUntilEnd);

    return () => clearTimeout(timeout);
  }, [open]);

  const t = useTranslations();
  const hasQuery = useSearchParams();

  const devMode = hasQuery?.get?.('devMode') === 'true';

  if (localHide) return <></>;

  return (
    <Dialog className={className} open={open && !devMode}>
      <DialogContent
        sx={{
          // background: '#1C1929',
          borderTop: 'none',
          paddingTop: '0',
          paddingBottom: '22px !important',
          paddingLeft: '32px !important',
          paddingRight: '32px !important'
        }}
      >
        <DialogTitle className='dialog_title'>
          <Typography variant='h4'>{t('timer.title')}</Typography>
          <LanguagePicker />
        </DialogTitle>
        <Box className='unit_wrapper textmd'>
          <Box className='timer_wrapper' sx={{ border: theme => `1px solid ${theme.palette.primary.main}` }}>
            <img className='timer_ny_head' src='/images/timer/timer_ny_head.png' alt='' />
            {targetDate && <MyTimer endDate={targetDate} onComplete={onClose} />}
          </Box>
        </Box>

        <Box className='timer_products_list'>
          <Box className='timer_products_item'>
            <img className='timer_products_img' src='/images/timer/product_1.png' alt='' />
            <img className='timer_products_coin' src='/images/timer/coin_1.png' alt='' />
          </Box>
          <Box className='timer_products_item'>
            <img className='timer_products_img' src='/images/timer/product_2.png' alt='' />
            <img className='timer_products_coin' src='/images/timer/coin_2.png' alt='' />
          </Box>
          <Box className='timer_products_item'>
            <img className='timer_products_img' src='/images/timer/product_3.png' alt='' />
            <img className='timer_products_coin' src='/images/timer/coin_3.png' alt='' />
          </Box>
          <Box className='timer_products_item'>
            <img className='timer_products_img' src='/images/timer/product_4.png' alt='' />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

TimerModal = styled(TimerModal, {
  '& .MuiDialogTitle-root': {
    padding: '0 !important'
  },
  '& > .MuiDialog-container > .MuiPaper-root': {
    margin: '16px !important',
    backgroundImage: 'url("/images/timer/timer_background.jpg")',
    backgroundColor: '#1c1929 !important',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    width: '100%',
    maxWidth: 850,
    '& .MuiDialogContent-root': {
      paddingTop: 24
    },

    '@toTablet': {
      maxWidth: '374px !important',
      backgroundImage: 'url("/images/timer/timer_background_mobile.jpg")',
      height: '93vh',

      '& .MuiDialogContent-root': {
        padding: '24px 24px 24px !important',
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'center',
        overflowX: 'hidden'
      }
    }
  },

  '& .dialog_title': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'center',
    position: 'relative',

    '@toTablet': {
      flexDirection: 'column-reverse',
      gap: '20px',
      marginBottom: 40
    }
  },
  '& .timer_title_wrapper': {
    marginLeft: 'auto'
  },
  '& .MuiTypography-root': {
    // paddingTop: '12px !important'
    // paddingBottom: '28px'
  },
  '@keyframes gradientShift': {
    '0%': {
      backgroundPosition: '0% 50%'
    },
    '50%': {
      backgroundPosition: '100% 50%'
    },
    '100%': {
      backgroundPosition: '0% 50%'
    }
  },
  '& .time_title': {
    fontWeight: '700 !important',
    textAlign: 'center',
    letterSpacing: '1.5px',
    padding: '0 32px',

    background: 'linear-gradient(270deg, #1D67B7, #2E4DBF, #5B3D99, #9B3B9B, #1D67B7)',
    backgroundSize: '800% 800%',
    animation: 'gradientShift 6s ease infinite',

    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: 'transparent'
  },
  '& .cross_img': {
    position: 'absolute',
    top: '32px',
    right: '32px',
    cursor: 'pointer',
    '@toTablet': {
      top: '16px',
      right: '16px'
    }
  },
  '& .unit_wrapper': {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    paddingTop: 50,
    marginBottom: 30,

    '@toTablet': {
      paddingTop: 0,
      marginBottom: 28,
      gap: '8px'
    },

    '& .timer_wrapper': {
      padding: '33px 66px',
      borderRadius: 20,
      position: 'relative',

      '@toTablet': {
        padding: '20px 40px'
      }
    },

    '& .timer_ny_head': {
      position: 'absolute',
      zIndex: 10,
      top: -70,
      right: -70,
      width: 155,

      '@toTablet': {
        width: 94,
        transform: 'rotate(-10deg)',
        top: -48,
        right: -36
      }
    },

    '& *': {
      fontFamily: '"Michroma", sans-serif'
    },

    '& .fcc__separator': {
      position: 'relative',

      '@toTablet': {
        marginBottom: 20
      },

      '&::after, &::before': {
        borderRadius: 0,
        width: 5,
        height: 5,

        '@toTablet': {
          width: 4,
          height: 4
        }
      },
      '&::before': {
        marginBottom: 8
      }
    },

    '& .timer_modal': {
      gap: 6
    },

    '& .timer_list': {
      display: 'flex'
    },

    '& .timer_block': {
      display: 'grid',
      justifyContent: 'center',
      alignItems: 'center'
    },

    '& .timer_number, & .timer_separator': {
      textAlign: 'center',
      fontSize: 56,
      color: '#fff',

      '@toTablet': {
        fontSize: 34
      }
    },

    '& .timer_number': {
      display: 'flex'
    },

    '& .timer_separator': {
      lineHeight: 1
    },

    '& .timer_number_num': {
      display: 'block',
      width: 54,
      lineHeight: 1,

      '@toTablet': {
        width: 32
      }
    },

    '& .timer_label': {
      // position: 'relative',
      marginTop: 20,
      fontSize: 25,
      fontWeight: 300,
      textTransform: 'uppercase',
      textAlign: 'center',
      lineHeight: 1,

      '@toTablet': {
        fontSize: 15,
        marginTop: 14
      }
    },

    '& .fcc__unit_time': {
      marginBottom: 50,

      '@toTablet': {
        marginBottom: 30
      }
    }
  },

  '& .timer_title': {
    fontSize: 42,
    textAlign: 'center',
    color: '#fff',

    '@toTablet': {
      fontSize: 18
    }
  },

  '& .timer_products_list': {
    display: 'flex',
    gap: 33,
    maxWidth: '100%',
    paddingBottom: 15,

    '@toTablet': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '27px 22px'
    }
  },

  '& .timer_products_item': {
    position: 'relative',

    '@toTablet': {
      '&:nth-child(1) > .timer_products_coin': {
        top: -34,
        transform: 'none'
      },
      '&:nth-child(2) > .timer_products_coin': {
        top: 'auto',
        right: 'auto',
        bottom: -44,
        left: -46,
        transform: 'none'
      },
      '&:nth-child(3) > .timer_products_coin': {
        top: 'auto',
        bottom: -24,
        transform: 'none'
      }
      // '&:nth-child(3) > .timer_products_coin': {
      //   bottom: -34,
      //   transform: 'none'
      // }
    }
  },

  '& .timer_products_img': {
    maxWidth: 190,
    width: '100%'
  },

  '& .timer_products_coin': {
    width: 98,
    position: 'absolute',
    zIndex: 10,
    top: '50%',
    right: -66,
    transform: 'translateY(-50%)',

    '@toTablet': {
      width: 68,
      right: -46
    }
  },

  '& .textmd': {
    fontSize: '20px'
  },
  '& .soon_item': {
    marginTop: '20px !important',
    color: 'white',
    fontWeight: 'medium !important',
    textAlign: 'center',
    letterSpacing: '1.5px'
  },
  '& .gradiented_title': {
    fontWeight: '600 !important',
    textAlign: 'center',
    letterSpacing: '1.5px',
    padding: '0 32px',
    fontSize: '48px !important',
    textTransform: 'capitalize',

    '@toTablet': {
      fontSize: '32px !important'
    },
    /* Градиент с множеством цветов */
    background: 'linear-gradient(90deg, #1d67b7, #2e4dbf, #5b3d99, #9b3b9b, #1d67b7, #2e4dbf, #5b3d99, #9b3b9b)',

    /* Очень большой размер, чтобы анимация была заметной */
    backgroundSize: '200% 100%',

    /* Анимация движения фона */
    animation: 'gradientText 4s ease-in-out infinite',

    /* Заливка текста градиентом */
    color: 'transparent !important',
    '-webkit-background-clip': 'text',
    'background-clip': 'text'
  }
});

export default memo(TimerModal);
